import { connect } from 'react-redux'
import ProductListViewPullSellersProductsToMyStore from './ProductListViewPullSellersProductsToMyStore'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewPullSellersProductsToMyStore)
